import { createNoParamsFetcher } from '../contexts/Fetcher';
import { apiProduct } from '../resources/api/apiProduct';

const { useGetProducts } = apiProduct;

export const ProductsFetcher = createNoParamsFetcher(() => {
  const { execute } = useGetProducts();

  return execute;
});
